module.exports = {"API_ENDPOINT":"https://www.messageinawindow.com/api"};